import React from "react";
import { useSmartObject, useNotification } from "@eveworld/contexts";
import { EveButton } from "@eveworld/ui-components";
import { useRecords } from "../mud/useRecords";
import { stash } from "../mud/stash";
import mudConfig from "../../../contracts/mud.config";

import { useWorldContract } from "../mud/useWorldContract";
import { Severity } from "@eveworld/types";
import { Address } from "viem";
import { bigIntSort } from "@latticexyz/common/utils";

import deleteHeadHunters from "./systemCalls/handleDeleteHeadHunters";

interface Props {
  inventoryList: JSX.Element[];
}

const InventoryListView = ({ inventoryList }: Props) => {
  const { smartAssembly } = useSmartObject();
  const { worldContract } = useWorldContract();
  const { notify } = useNotification();

  const highScoreRecords = useRecords({
    stash,
    table: mudConfig.namespaces.Tapticc.tables.HeadHunters,
  });

  const highScoreEntities = React.useMemo(() => {
    return Object.values(highScoreRecords).sort((a, b) =>
      bigIntSort(a.points, a.points)
    ); //b then a to sort descending
  }, [highScoreRecords]);

  var smartCharacterIds: Address[] = [];

  highScoreEntities.forEach((record) => {
    smartCharacterIds.push(record.smartCharacterId);
  });

  const handleDeletePoints = async () => {
    const txHash = await deleteHeadHunters({
      worldContract,
      smartObjectId: smartAssembly?.id || import.meta.env.VITE_SMARTASSEMBLY_ID,
      smartCharacterIds: smartCharacterIds,
    });
    if (txHash) {
      notify({ type: Severity.Success, txHash });
    } else {
      notify({
        type: Severity.Error,
        message: "Transaction failed to execute",
      });
    }
  };

  if (
    worldContract?.account?.address.toLocaleLowerCase() ==
    import.meta.env.VITE_TAPTICC_ADDRESS.toLocaleLowerCase()
  ) {
    return (
      <>
        <div className="grid grid-cols-1 mobile:grid-cols-1 bg-crude">
          <div className="text-l my-2 text-center">
            You have the following items safely stored in this SSU:
            <EveButton
              typeClass="primary"
              className="primary-sm"
              style={{
                width: "175px",
              }}
              onClick={() => handleDeletePoints()}
              disabled={false}
              id="DeletePoints"
            >
              Delete Points
            </EveButton>
          </div>
          <div className="contents empty-span-full text-xs">
            <table style={{ width: "100%" }}>
              <tbody>{inventoryList}</tbody>
            </table>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="grid grid-cols-1 mobile:grid-cols-1 bg-crude">
          <div className="text-l my-2 text-center">
            You have the following Strangers Heads in this Storage Unit:
          </div>
          <div className="contents empty-span-full text-xs">
            <table style={{ width: "100%" }}>
              <tbody>{inventoryList}</tbody>
            </table>
          </div>
        </div>
      </>
    );
  }
};

export default React.memo(InventoryListView);
